import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class OutlookAccount extends BaseEntityModel {
  id?: number;
  userId?: number;
  email?: string;

  constructor(model: Partial<OutlookAccount> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.email = model.email;
  }
}
